import * as Yup from 'yup'

export default Yup.object({
  Notes: Yup.string().required()
})
